import { useToast } from '@/hooks/use-toast';
import { getErrorSupportMessage, normalizeApiError } from '@/lib/errors';

interface AppErrorToastOptions {
  title: string;
  fallbackMessage?: string;
}

export const useAppErrorToast = () => {
  const { toast } = useToast();

  const showErrorToast = (error: unknown, options: AppErrorToastOptions) => {
    const normalizedError = normalizeApiError(error);

    toast({
      variant: 'error',
      title: options.title,
      description: normalizedError.message
        ? getErrorSupportMessage(normalizedError)
        : options.fallbackMessage,
    });

    return normalizedError;
  };

  return { showErrorToast };
};
